import React from "react";

export function CentralCredentialsCardInput({ label, value, onChange, valid, type, onFocus, required = false }) {
    const fieldId = `oct-central-credentials-${label.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`;

    return (
        <div className="form-group oct_auth-v2-field">
            <div className="oct_auth-v2-form-group">
                <label htmlFor={fieldId} className="oct_auth-v2-label">
                    {label}
                    {required && <span className="modal-v2-required-mark">*</span>}
                </label>
                <input
                    id={fieldId}
                    type={type || 'text'}
                    className={`form-control oct_auth-v2-input ${valid ? '' : 'border-danger'}`}
                    value={value}
                    onChange={event => onChange(event.target.value)}
                    onFocus={onFocus}
                />
            </div>
        </div>
    )
}
